import { SelectRowProps } from "react-bootstrap-table-next";
import SpinnerComponent from "../../../Components/Loding/Spinner";
import { useState } from "react";
import { IComponentModal } from "../../../Components/Modais/IModalComponent";
import ModalComponent from "../../../Components/Modais";
import {
    AtualizarNotificacaoComoLida,
    AtualizarNotificacaoComoNaoLida,
    AtualizarNotificacaoLidaController,
    AtualizarNotificacaoNaoLidaController,
    ListarGrupoNotificacoesController,
} from "../../../Controllers/Geral/Notificacao/NotificacaoControllers";
import { INotificacao } from "../../../Interfaces/Geral/Notificacao/NotificacaoInterfaces";
import {
    DataTable,
    IDataTableColumn,
} from "../../../Components/Table/DataTable";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckDouble, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import VerAtendimento from "../../../Components/CardsPages/Atendimento/VerAtendimento";
import { useParams } from "react-router";

interface URLParams {
    tipo: string;
}

export default function GestaoDeNotificacoes() {
    const { tipo }: URLParams = useParams();
    const { value: retornoNotificacoes, ...ListarNotificacoes } =
        useAsyncEffect(() => {
            return ListarGrupoNotificacoesController(
                0,
                handleParams() ?? false
            );
        }, [tipo]);
    const lstNotificacoes = retornoNotificacoes?.LSTNOTIFICACOES;
    const totalPages = retornoNotificacoes?.TOTAL_PAGES;

    const [show, setShow] = useState(false);
    const [modal] = useState<IComponentModal>();

    const [lstSelecionados, setlstSelecionados] = useState<Array<INotificacao>>(
        []
    );

    function handleParams() {
        if (tipo === "notificacoes") {
            return false;
        } else {
            return true;
        }
    }

    const selectRowProp: SelectRowProps<INotificacao> = {
        mode: "checkbox",
        onSelect: (row, isSelect) => {
            row.FL_MARC = isSelect;
            const lstParcelasMarcadas =
                lstNotificacoes?.filter((p) => p.FL_MARC) ?? [];
            setlstSelecionados(lstParcelasMarcadas);
        },
        onSelectAll: (isSelect, rows: Array<INotificacao>) => {
            rows.forEach((row) => {
                row.FL_MARC = isSelect;
            });
            const lstParcelasMarcadas =
                lstNotificacoes?.filter((p) => p.FL_MARC) ?? [];
            setlstSelecionados(lstParcelasMarcadas);
        },
        selected: lstSelecionados.map((selecionados) => {
            return selecionados.ID_NOTIFICACAO;
        }),
    };
    //tabela
    const tableColumns: Array<IDataTableColumn<INotificacao>> = [
        {
            headerAlign: "center",
            dataField: "DS_NOTIFICACAO",
            text: "Notificação",
            align: "center",
            formatoPadrao: "html",
            bigTextMaxChar: 110,
        },
        {
            headerAlign: "center",
            dataField: "ID_CASO",
            text: "Atendimento",
            align: "center",
            formatter: (c, row) => (
                <VerAtendimento
                    ID_CASO={c}
                    ID_TIPO_CASO={row.ID_TIPO_CASO ?? 0}
                />
            ),
        },
        {
            headerAlign: "center",
            dataField: "DT_CRIACAO",
            text: "Data",
            align: "center",
            formatoPadrao: "date",
        },
        {
            headerAlign: "center",
            dataField: "DT_LEITURA",
            text: "Lido em",
            align: "center",
            formatoPadrao: "date",
        },
        {
            dataField: "",
            text: "",
            isDummyField: true,
            formatter: (_, row) => (
                <div className="d-flex g-2 p-2">
                    <div>
                        {row.FL_LIDO === true ? (
                            <OverlayTrigger
                                overlay={
                                    <Tooltip id="remover-tooltip">
                                        Marcar como não Lida
                                    </Tooltip>
                                }
                            >
                                <button
                                    className="btn btn-icon btn-outline-info"
                                    onClick={() => {
                                        AtualizarNotificacaoComoNaoLida(
                                            row.ID_NOTIFICACAO
                                        ).then(ListarNotificacoes.execute);
                                    }}
                                >
                                    <FontAwesomeIcon icon={faEyeSlash} />
                                </button>
                            </OverlayTrigger>
                        ) : (
                            <OverlayTrigger
                                overlay={
                                    <Tooltip id="remover-tooltip">
                                        Marcar como Lida
                                    </Tooltip>
                                }
                            >
                                <button
                                    className="btn btn-icon btn-outline-primary"
                                    onClick={() => {
                                        AtualizarNotificacaoComoLida(
                                            row.ID_NOTIFICACAO
                                        ).then(ListarNotificacoes.execute);
                                    }}
                                >
                                    <FontAwesomeIcon icon={faCheckDouble} />
                                </button>
                            </OverlayTrigger>
                        )}
                    </div>
                </div>
            ),
        },
    ];

    return (
        <>
            <div className="card card-custom">
                <div className="card-body mt-n5">
                    <div className="d-inline-flex justify-content-end flex-wrap w-100 g-4 mb-4">
                        <button
                            disabled={lstSelecionados.length <= 0}
                            className="btn btn-primary align-items-center flex-grow-1 flex-md-grow-0"
                            type="button"
                            onClick={() => {
                                AtualizarNotificacaoLidaController(
                                    lstSelecionados
                                ).then(ListarNotificacoes.execute);
                            }}
                        >
                            <FontAwesomeIcon icon={faCheckDouble} /> Marcar
                            Notificações como Lidas
                        </button>

                        <button
                            disabled={lstSelecionados.length <= 0}
                            className="btn btn-info align-items-center flex-grow-1 flex-md-grow-0"
                            type="button"
                            onClick={() => {
                                AtualizarNotificacaoNaoLidaController(
                                    lstSelecionados
                                ).then(ListarNotificacoes.execute);
                            }}
                        >
                            <FontAwesomeIcon icon={faEyeSlash} /> Marcar
                            Notificações como Não Lidas
                        </button>
                    </div>
                    {lstNotificacoes ? (
                        <DataTable
                            columns={tableColumns}
                            data={lstNotificacoes}
                            keyField="ID_NOTIFICACAO"
                            selectRow={selectRowProp}
                            loading={ListarNotificacoes.loading}
                            noPagination
                            rowClasses={(row) =>
                                `checkbox-table ${
                                    row.FL_LIDO ? "bg-secondary" : ""
                                }`
                            }
                            noDataIndication={
                                <div className="text-center text-black-50">
                                    Nenhuma notificação encontrada
                                </div>
                            }
                            tableView={{
                                striped: false,
                                hover: false,
                                cancelYScroll: true,
                            }}
                            bordered={true}
                            noHover
                            totalPages={totalPages}
                        />
                    ) : (
                        ListarNotificacoes.loading && <SpinnerComponent />
                    )}
                </div>
                <ModalComponent
                    ModalComponent={modal}
                    setShow={setShow}
                    show={show}
                />
            </div>
        </>
    );
}
